import React from "react";
import { formatNumber } from "../../utils/formatNumber";
import { useSelector } from "react-redux";
import { Progress } from "semantic-ui-react";

const CommonProgress = ({ firstValue, secondValue }) => {
  return (
    <>
      <div className="flex items-center justify-between text-light-text text-sm font-semibold mb-[5px]">
        <p className="mb-0">
          {formatNumber(firstValue)}
          <span className="mx-[5px]">/</span>
          {formatNumber(secondValue)}
        </p>
        <p className="mb-0">
          {formatNumber((firstValue / secondValue) * 100)}%
        </p>
      </div>
      <Progress
        className="customUi customUiHeight !mb-[5px]"
        percent={formatNumber((firstValue / secondValue) * 100)}
        size="tiny"
        success
      />
    </>
  );
};

export default CommonProgress;
